import {
  CLEAR_EXAMPLES,
  GET_EXAMPLES
} from './constants';

export function loadExamples(service) {
  return dispatch => dispatch({
    type: GET_EXAMPLES,
    request: {
      method: 'GET',
      endpoint: 'examples/',
      queryParams: {
        service
      }
    }
  });
}

export function clearExamples() {
  return dispatch => dispatch({
    type: CLEAR_EXAMPLES
  });
}



// WEBPACK FOOTER //
// ./src/redux/Examples/actions.js